module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK4AAABsCAMAAADE8nljAAAAOVBMVEUAAAC5mFi5k1q6klq7lVq3k1i7lFu7lFu7lFu7lFu/j2C8lVy7k1qvj1C5lFq6k1q6lVq6j1q7lFvyJ2QGAAAAEnRSTlMAH4Bgn0C/3+/PEG9QELCQMDAbJOu5AAAA6klEQVR42u3bSQ7DIAxAUQg0kKkD9z9sK6VyI0UdrCyC0/+3IPTWYNzkDTW5VAyVXDEV3EVwTQVX0Qbupam2uOaeXcV1K250FdfCfQUXrgQXrgQXrgQXrgQXrgT3kFwf5xonqTcNUZHfxG3KMzlGvakvmuLeXA8XLly465KGG3bn6oILFy5cuHDhwoULFy5cuHAfwYULF+7BuEOr6Op4Sjnw/S5cuHC/c095Xk39B+5Y5rp3o82/l8d/GhCoJLiL4MKV4MKV4MKV4MKV4MKV4Brn5nCqtmD/07iJ4C6Caypr3FwMlZwPhrrdAXpYnHYFqKA+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-brand-gold.png
// module id = 194
// module chunks = 0